export default "__VITE_ASSET__654fc772__"